import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "v-reschedule-procedure" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Detalhes do procedimento")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "no estabelecimento", -1)
const _hoisted_4 = {
  key: 1,
  class: "reschedule-procedure-form"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Data ")

import { computed, reactive, ref, watch } from "vue";
import { useHead } from "@vueuse/head";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import { ObSpinner, ObCalendarInline } from "@/libs/components";
import ObStepFlow from "@/components/step-flow.vue";

import { formatDate, formatDateEn } from "@/libs/utils";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

useHead({ title: "Reagendar procedimento | obmed" });

const store = useStore();
const route = useRoute();
const router = useRouter();

const form = computed(() => store.state.user.appointment.rescheduleForm);
const currentFlow = computed(
  () => (({ E: "image", L: "laboratory", P: "procedure" } as any)[route.query.te?.toString() || "P"])
);

const selectedDate = ref<string | null>(null);
const selectedTime = ref<string | null>(null);
const selectedTimeOption = ref<any | null>(null);
const selectedItem = computed(() =>
  selectedDate.value ? store.state.establishment.list[formatDate(selectedDate.value)]?.[0] : null
);

const availableDates = computed(() => Object.keys(store.state.establishment.list));
const loading = reactive({ list: true });

async function getAvailableDates() {
  loading.list = true;

  await store.dispatch(
    currentFlow.value === "laboratory"
      ? "getAllEstablishmentByLaboratory"
      : currentFlow.value === "image"
      ? "getAllEstablishmentByExam"
      : "getAllEstablishmentByProcedure",
    {
      cd_procedimento: form.value.cd_procedimento,
      cd_estabelecimento: Number(form.value.cd_estabelecimento),
    }
  );

  if (!availableDates.value.length) {
    selectedDate.value = null;

    store.commit("addToast", {
      summary: "Nenhum horário disponível no momento, tente novamente mais tarde!",
      severity: "warn",
    });
    router.replace({ name: "appointment" });
  } else if (!selectedDate.value) selectedDate.value = selectedDate.value = formatDateEn(availableDates.value[0]);

  loading.list = false;
}

watch(selectedDate, async (date) => {
  selectedTime.value = "";
  if (!date) return;

  const freeTime = selectedItem.value?.hr_horario?.find((item) => item.ie_status === "L");
  selectedTime.value = freeTime?.hr_agenda || "";

  await router.replace({ query: { ...route.query, time: freeTime?.hr_agenda, se: freeTime?.id } });
  await router.replace({ query: { ...route.query, date } });
});
watch(selectedTimeOption, (option) => {
  if (!option?.value) return;
});

if (!form.value.cd_procedimento?.length) router.replace({ name: "appointment" });
else getAvailableDates();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(ObStepFlow, {
      "element-id": "reschedule-procedure-details",
      "disable-edit": ""
    }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        (_unref(selectedItem))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("b", null, _toDisplayString(_unref(selectedItem)?.nm_procedimento || "-"), 1),
              _hoisted_3,
              _createElementVNode("b", null, _toDisplayString(_unref(selectedItem)?.nm_estabelecimento || _unref(selectedItem)?.nm_fantasia || "-"), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(loading).list && !_unref(availableDates)?.length)
      ? (_openBlock(), _createBlock(_unref(ObSpinner), {
          key: 0,
          style: {"margin-top":"4rem"}
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!_unref(loading).list && _unref(availableDates)?.length)
            ? (_openBlock(), _createBlock(_unref(ObCalendarInline), {
                key: 0,
                modelValue: selectedDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                "element-id": "reschedule-procedure-calendar-date",
                validDates: _unref(availableDates)
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["modelValue", "validDates"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})